"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
jquery_1["default"](function () {
    /* Interface to view the workflow status from the explorer / editor */
    // eslint-disable-next-line func-names
    jquery_1["default"]('button.action-workflow-status').on('click', function () {
        // eslint-disable-next-line no-undef, new-cap
        ModalWorkflow({
            url: this.getAttribute('data-url'),
        });
        return false;
    });
});
